import React from "react";
import api, { apiError } from "@/api";
import { Trash2, FileText } from "lucide-react";
import { toast } from "sonner";

export const VisitsLog = ({ visits, readOnly, onChanged }) => {
  const remove = async (v) => {
    if (!window.confirm("حذف سجل المتابعة؟")) return;
    try { await api.delete(`/my-visits/${v.id}`); toast.success("تم الحذف"); onChanged(); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (!visits.length) return <div className="text-center text-stone-500 text-sm py-8" data-testid="visits-empty">لم تسجّل أي متابعة بعد.</div>;
  return (
    <div className="space-y-2" data-testid="visits-log">
      {visits.map((v) => (
        <div key={v.id} data-testid={`visit-${v.id}`} className="rounded-xl bg-white/80 border border-amber-400/20 p-3">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <div className="font-semibold text-stone-800 text-sm truncate">{v.school_name}</div>
              <div className="text-xs text-stone-500 mt-0.5 flex flex-wrap gap-2">
                <span>{v.date}</span><span className="text-sky-700">{v.kind}</span>
                {v.status && <span className="text-amber-700">{v.status}</span>}
              </div>
            </div>
            {!readOnly && <button data-testid={`visit-del-${v.id}`} onClick={() => remove(v)} className="p-1.5 rounded-lg hover:bg-red-500/15 text-red-700 shrink-0"><Trash2 size={15} /></button>}
          </div>
          {v.notes && <p className="text-sm text-stone-700 mt-2 whitespace-pre-wrap">{v.notes}</p>}
          {v.attachment && (v.attachment.startsWith("data:application/pdf")
            ? <a href={v.attachment} download="تقرير-المتابعة.pdf" className="text-xs text-sky-700 underline mt-2 inline-flex items-center gap-1"><FileText size={13} /> عرض ملف PDF</a>
            : <img src={v.attachment} alt="مرفق" className="mt-2 max-h-40 rounded-lg border border-amber-400/20" />)}
        </div>
      ))}
    </div>
  );
};

export default VisitsLog;
